import { RouterProvider } from "@tanstack/react-router";

import { AppProviders } from "./providers/AppProviders";
import { queryClient } from "./queryClient";
import { router } from "./router";

export const App = () => (
  <AppProviders>
    <RouterProvider router={router} context={{ queryClient }} />
  </AppProviders>
);
